import TranslationText from '@Components/Utilities/TranslationText';
import translator from '@Components/Utilities/Translator';
import atoms from '@Components/Utilities/SandhillsAtoms';
import { useSetRecoilState } from 'recoil';
import { loadable } from '@Components/Utilities/SandhillsLoadable';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { gtmPushEvent } from '@Components/Utilities/SandhillsUtility';

const GrainMarketTable = loadable(() => import('@Components/Home/GrainMarketTable'));

const AboutUs = (props) => {

    const setShowQsuModal = useSetRecoilState(atoms.showQsu);
    const ShowQSUModal = () => {
        setShowQsuModal(true);
        gtmPushEvent('quick-sign-up-open', 'qsuTriggerType', 'Click');
    }

    const onKeyDown = (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            ShowQSUModal();
        }
    };

    return (
        <div className={props.className}>
            {props.GrainMarketModel && <GrainMarketTable {...props.GrainMarketModel} />}
            <h2 className='section-title'>
                <span className='section-title-text'>
                    <TranslationText tKey='sandhills.tradepubwebsite.mvc.aboutus' />
                </span>
            </h2>
            <div className='about-us-content'>
                <div className='about-us-description'>
                    <div dangerouslySetInnerHTML={{ __html: props.AboutUsText }}></div>
                </div>
                {props.AboutUsImageURL &&
                    <LazyLoadImage className='about-us-image' src={props.AboutUsImageURL} alt='' />}
            </div>
            <div className='subscription-container'>
                <div className='subscription-content'>
                    <div className='subscription-content_buttons'>
                        {props.ShowAdvertisingLink &&
                            <a className='subscription-content_buttons-advertising' id='homepage-advertising-button' href={props.AdvertisingURL}>
                                <TranslationText tKey='sandhills.advertisingdetails' />
                            </a>}
                        {props.ShowSubscribeButton &&
                            <a role="button" tabIndex="0" className='subscription-content_buttons-subscription' id='homepage-subscribe-button' onKeyDown={onKeyDown} onClick={() => ShowQSUModal()}>
                                <TranslationText tKey='sandhills.subscribetoreceiveemailupdates'  />
                        </a>}
                    </div>
                    <div>
                        {props.PacificLogo && <LazyLoadImage className='subscription-content-logo' src={props.PacificLogo} alt='' />}
                    </div>
                </div>
            </div>
            {(props.MobileDownload &&
                props.MobileDownload.DownloadImage &&
                props.MobileDownload.AppleDownloadUrl &&
                props.MobileDownload.AppleQRCodeImage &&
                props.MobileDownload.AppleDownloadImage &&
                props.MobileDownload.AndroidDownloadUrl &&
                props.MobileDownload.AndroidDownloadImage &&
                props.MobileDownload.AndroidQRCodeImage) &&
                <div className='mobile-download'>
                    <div className='app-download-image'>
                        <LazyLoadImage src={props.MobileDownload.DownloadImage} alt={translator.translate('sandhills.downloadourmobileapp')} />
                    </div>
                    <div className='app-download-container'>
                        <h3 className='app-download-title'><strong><TranslationText tKey='sandhills.mobileapps.download' /></strong> <TranslationText tKey='sandhills.ourmobileapp' /></h3>
                        <a className='apple-btn' id='apple-btn' href={props.MobileDownload.AppleDownloadUrl} target='_blank' rel='noopener'>
                            <span className='visually-hidden'> {translator.translate('sandhills.downloadiphone')} {translator.translate('sandhills.opensinanewtab')} </span>
                            <LazyLoadImage className='qr-code' src={props.MobileDownload.AppleQRCodeImage} alt={translator.translate('sandhills.qrcode')} />
                            <LazyLoadImage src={props.MobileDownload.AppleDownloadImage} alt='' />
                        </a>
                        <a className='android-btn' id='android-btn' href={props.MobileDownload.AndroidDownloadUrl} target='_blank' rel='noopener'>
                            <span className='visually-hidden'>{translator.translate('sandhills.downloadandroid')} {translator.translate('sandhills.opensinanewtab')} </span>
                            <LazyLoadImage src={props.MobileDownload.AndroidDownloadImage} alt='' />
                            <LazyLoadImage className='qr-code' src={props.MobileDownload.AndroidQRCodeImage} alt={translator.translate('sandhills.qrcode')} />
                        </a>
                    </div>
                </div>}
        </div>
    );
};

export default AboutUs;